import { RealtimeInboxComponent } from 'src/app/shared/repair-chat/realtime-inbox.component';
import {Component, EventEmitter, Input, Output, ViewEncapsulation,} from '@angular/core';
import {CoreService} from 'src/app/services/core.service';
import {MatDialog} from '@angular/material/dialog';
import {navItems} from '../sidebar/sidebar-data';
import {TranslateService} from '@ngx-translate/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from 'src/app/material.module';
import {Router, RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgScrollbarModule} from 'ngx-scrollbar';
import { NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { formatString as utilFormatString } from 'src/app/shared/string-utils';
import { clearSessionToken } from 'src/app/utils/session-token';
import { UsersService } from 'src/app/services/api/loggedServices/users/users.service';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RealtimeInboxComponent,
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  public selectedLanguage: any

  public userEmail : any
  public userName : any
  public userImg : any
  
  notifications: any[] = [];
  unreadCount: number = 0;

  constructor (
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router,
    private notificationsService: NotificationsService,
    private usersService: UsersService
  ) {

  }
  ngOnInit(){
    this.userEmail = localStorage.getItem("mail") || localStorage.getItem("userEmail") || ''
    const storedImg = (localStorage.getItem("img") || localStorage.getItem("userImage") || "").trim();
    this.userImg = storedImg || "/assets/images/profile/noUser.jpg"
    this.userName = localStorage.getItem("name") || localStorage.getItem("userName") || ''

    this.translate.addLangs(['en', 'es', 'fr', 'ca', 'eu', 'pt'])
    if (localStorage.getItem('lang') == null) {
      var timezone = Intl.DateTimeFormat().resolvedOptions().locale
      var timezoneCode = timezone.toString().substr(0, timezone.length - 3)
      localStorage.setItem('lang', timezoneCode)
    }else{
      var timezoneCode = localStorage.getItem('lang')
    }
    for(var lang of this.languages){
      if(lang.code == timezoneCode){
        this.selectedLanguage = lang
      }
    }
    this.translate.setDefaultLang(timezoneCode);

    // Llama a los servicios de notificaciones al iniciar
    this.loadNotifications();
    this.loadSessionUserProfile();
    // Exponer función global para refrescar desde fuera (dashboard)
    (window as any).updateHeaderNotifications = () => this.loadNotifications();
  }

  loadSessionUserProfile(): void {
    this.usersService.loadSessionUserDetail().subscribe({
      next: (data: any) => {
        const name = (data?.firstName || data?.userName || localStorage.getItem('name') || '').toString();
        const lastName = (data?.lastName || '').toString();
        const email = (data?.email || localStorage.getItem('mail') || '').toString();
        const image = (data?.imageUrl || localStorage.getItem('img') || '/assets/images/profile/noUser.jpg').toString();

        this.userName = [name, lastName].filter((v) => !!v).join(' ').trim();
        this.userEmail = email;
        this.userImg = image;

        if (this.userName) {
          localStorage.setItem('name', this.userName);
        }
        if (this.userEmail) {
          localStorage.setItem('mail', this.userEmail);
        }
        if (this.userImg) {
          localStorage.setItem('img', this.userImg);
        }
      }
    });
  }

  formatString(str : any) {
    return utilFormatString(str);
  }

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'Português',
      code: 'pt',
      icon: '/assets/images/flag/icon-flag-pt.svg',
    },
    {
      language: 'Catalán',
      code: 'ca',
      icon: '/assets/images/flag/ca.svg',
    },
    {
      language: 'Euskera',
      code: 'eu',
      icon: '/assets/images/flag/eu.svg',
    },
  ];


  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    localStorage.removeItem('lang')
    localStorage.setItem('lang', lang.code)
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  loadNotifications() {
    this.notificationsService.getUnreadNotifications().subscribe((data: any) => {
      this.notifications = (data ?? [])
        .sort((a: any, b: any) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
        .slice(0, 5);
    });
    this.notificationsService.getUnreadCount().subscribe((data: any) => {
      this.unreadCount = data.unread ?? 0;
    });
  }

  goToNotificationsDashboard(notification?: any) {
    if (notification && notification.uuid) {
      this.router.navigate(['/management/notifications'], { queryParams: { uuid: notification.uuid } });
    } else {
      this.router.navigate(['/management/notifications']);
    }
  }

  logout(): void {
    clearSessionToken();
    localStorage.removeItem('mail');
    localStorage.removeItem('name');
    localStorage.removeItem('img');
    this.router.navigateByUrl('/authentication/login');
  }

  profiledd: profiledd[] = [
     {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'my-account',
      subtitle: 'Account Settings',
      link: '/my-acount/profile',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-user-male.svg',
      title: 'users',
      subtitle: 'Company Users',
      link: '/my-acount/users',
    }
  ];
}

@Component({
  selector: 'search-dialog',
  standalone: true,
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  constructor(public router : Router) { }

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  searchDeviceFromSerialNumber(){
    this.router.navigate(['management/main', this.searchText])
  }
}
